import {RestQueryParams} from 'educat-common-web';
import {Observable} from 'rxjs';
import {educatAPI} from "educat-common-web";


export function getTrialMarginAPI(
    authToken: string | null
): Observable<any> {
    let headers = undefined;
    if (authToken) {
        headers = {
            Authorization: `Bearer ${authToken}`,
        };
    }
    return educatAPI.get(
        `mentors/trial_margin`,
        new RestQueryParams(),
        headers
    );
}
